import axios from "axios";
import { CONFIG } from "../../config";
export const getQuizesByQuizeId = async (quizId) => {
	try {
		const response = await axios.get(
			`${CONFIG.SCHOOLURL}/quiz-questions/get-by-quiz/${quizId}`
		);
		return response.data;
	} catch (error) {
		return "error";
	}
};